<!-- eslint-disable vue/html-self-closing -->
<template>
  <a
    class="d-flex align-items-center codeowners__item-users-link"
    :class="{ 'has-error': hasError }"
    :style="showName ? 'gap: 4px' : ''"
  >
    <gf-custom-tooltip :container="container">
      <template #element>
        <img
          @click.prevent="openNewUserPage"
          :src="user.avatar || '/static/image/avatar.jpg'"
          class="avatar rounded-circle"
          :width="imageSize"
          :height="imageSize"
        />
      </template>
      <template
        v-if="showTooltip && (user.username || user.fullName)"
        #content
      >
        <span class="user-label-item-info-username">
          {{ user.fullName || user.emailAddress }}
        </span>
      </template>
      <template
        v-else-if="showTooltip && !user.username && !user.fullName"
        #content
      >
        <span class="user-label-item-info-username">
          {{ user.title }}
        </span>
      </template>
    </gf-custom-tooltip>
    <template v-if="showName && user.username">
      <a
        @click.prevent="openNewUserPage"
        class="text-nowrap d-flex flex-column user-label-item-info overflow-hidden mr-auto"
      >
        <span
          style="line-height: normal"
          class="mr-2 user-label-item-info-username"
          :class="{ 'font-weight-bolder': isBold }"
        >
          {{ user.fullName || user.emailAddress }}
        </span>
        <small
          v-if="showUserName && user.username"
          style="font-size: 12px"
          class="user-label-item-info-username"
        >
          @{{ user.username }}
        </small>
      </a>
      <span class="d-flex align-items-center justify-self-end">
        <i
          v-if="deletable"
          class="gf-icon gf-icon-x ml-auto mr-1"
          @click="$emit('delete', user)"
        ></i>
      </span>
    </template>

    <template v-if="showName && !user.username">
      <div
        style="line-height: normal"
        @click.prevent="openNewUserPage"
        class="d-flex flex-column user-label-item-info w-100"
      >
        <span
          style="line-height: normal"
          class="font-weight-bolder mr-2 user-label-item-info-username"
        >
          {{ user.title }}
        </span>
        <small
          v-if="user.alias"
          style="font-size: 12px"
          class="user-label-item-info-username"
        >
          @{{ user.alias }}
        </small>
      </div>
      <span class="d-flex align-items-center">
        <i
          v-if="deletable"
          class="gf-icon gf-icon-clock ml-auto mr-1"
          @click="$emit('delete', user)"
        ></i>
      </span>
    </template>
  </a>
</template>

<script>
import GfCustomTooltip from '@shared/shared-components/shared/GfCustomTooltip';

export default {
  name: 'UserLabelItem',
  components: { GfCustomTooltip },
  props: {
    user: {
      default: null
    },
    deletable: {
      default: false
    },
    showName: {
      default: true
    },
    showUserName: {
      default: true
    },
    showTooltip: {
      default: false
    },
    hasUserLink: {
      default: false,
      type: Boolean
    },
    openInNewTab: {
      default: true,
      type: Boolean
    },
    isBold: {
      default: true,
      type: Boolean
    },
    imageSize: {
      default: 28
    },
    // контейнер для tooltip. Описание в самом tooltip
    container: {
      type: String,
      default: 'body'
    },
    hasError: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    userProfileUrl() {
      return this.user.username ? `/user/${this.user.username}` : null;
    }
  },
  methods: {
    openNewUserPage() {
      if (!this.hasUserLink || !this.userProfileUrl) return;
      this.openInNewTab
        ? window.open(this.userProfileUrl, '_blank')
        : (window.location.href = this.userProfileUrl);
    }
  }
};
</script>

<style scoped lang="scss">
.avatar {
  object-fit: cover;
}

.codeowners {
  &__item-users-link {
    cursor: pointer;
    text-decoration: none !important;
    color: var(--text) !important;
  }

  .project-issue-form &__item-users-link,
  .merge-request__edit &__item-users-link {
    padding: 4px;
  }
}

.has-error {
  background-color: var(--gf-alert-danger-bc);
  padding: 4px;
  border-radius: var(--border-radius);
}
</style>
